import gql from "graphql-tag"
import MediaRevisionFragment from "../fragment/MediaRevisionFragment"

export default gql`
  ${MediaRevisionFragment}
  mutation mediaUpgradeConfirm($revisionId: String!, $allowRegression: Boolean!) {
    revision: mediaUpgradeConfirm(revisionId: $revisionId, allowRegression: $allowRegression) {
      ...MediaRevisionFragment
    }
  }
`
